import { __ } from '@wordpress/i18n';
import FieldOption from './FieldOption';

const FieldOptions = ({ options, onSelect }) => {
  if (options.length === 0) {
    return <p className="hvnly--builder---api_property__builder___info_text">{__('Nothing available', 'havenlytics')}</p>;
  }

  return (
    <div className="hvnly--builder---api_property__builder___field_options">
      {options.map((option) => (
        <FieldOption 
          key={option.id} 
          option={option} 
          onSelect={onSelect} 
        />
      ))}
    </div>
  );
};

export default FieldOptions;